module.exports = __webpack_public_path__ + "static/assets/781cb4b4d132122edb8ac1413e2e2ef0.png";